
import { AppAnnotation4Answers } from "@/interfaces/candidate/canidate_assessments";
import { AppAssessments } from "@/interfaces/data_objects/app_assessments";
import Vue, { PropType } from "vue";
export default Vue.extend({
  name: "AppAnnotationPart4",
  data() {
    return {
      options: [] as AppAnnotation4Answers[]
    };
  },
  props: {
    question: {
      type: Object as PropType<AppAssessments.AssessmentQuestionnaires>,
      required: true
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    question: {
      handler() {
        this.init();
      },
      immediate: true
    }
  },
  methods: {
    init() {
      this.options = [];
      const savedAnswer = this.question.answer?.answer;
      if (Array.isArray(savedAnswer) && savedAnswer.length > 0) {
        this.options = JSON.parse(JSON.stringify(savedAnswer));
        return;
      }
      if (
        this.question.question_options &&
        this.question.question_options.responses
      ) {
        for (let res of this.question.question_options.responses) {
          if (!res.content || !res.title) continue;
          this.options.push({
            answer: "",
            title: res.title,
            content: res.content
          });
        }
      }
    },
    submit_ans() {
      this.$emit("annotation-4", this.options);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    event_cancellation(event: any) {
      event.preventDefault();
    }
  }
});
